import { 
  rechargeActivityApi, 
  rechargeActivityClaimApi, 

  invitationActivityApi, 
  invitationActivityClaimApi,
  
  lossReliefActivityApi, 
  lossReliefActivityClaimApi,

  rechargeRebateActivityCheckApi, 
  rechargeRebateActivityClaimApi,
} from '../../api/activity'
import { Message } from 'element-ui';
import i18n from "../../utils/lang/index.js";

export default {
  state: {
    rechargeActivityList: [],
    invitationActivityList: [],
    reliefActivityList: [],
    rechargeRebateDetails: {
      claimed_at: "",
      event_ended_at: "",
      id: 0,
      is_claimed: 0,
      required_amount: "",
      reward_amount: 0,
    },
    activityDetailList: []
  },
  getters: {},
  mutations: {
    setRechargeActivityList(state, data) {
      state.rechargeActivityList = data;
    },
    setInvitationActivityList(state, data) {
      state.invitationActivityList = data;
    },
    setReliefActivityList(state, data) {
      state.reliefActivityList = data;
    },
    setRechargeRebateDetails(state, data) {
      state.rechargeRebateDetails = data;
    },
    setActivityDetailList(state, data) {
      state.activityDetailList = data;
    },
  },
  actions: {
    // RECHARGE ACTIVITY
    getRechargeActivityList(context, params) {
      rechargeActivityApi(params).then(res => {
        context.commit("setRechargeActivityList", res.data);
      }).catch(err => {
        Message.error(err.response.data.message)
      });
    },
    setRechargeActivity(context, params){
      rechargeActivityClaimApi(params).then(res => {
        let getPaymentType = context.rootState.recharge.paymentList.payment_type
        let userInfo = context.rootState.auth.userInfo
        if (res.code == 200 && res.status == "success") {
          // context.dispatch('setRecharge',{
          //   attach: null,
          //   bank_code: "NA",
          //   money: params.reward_amount,
          //   payment_desc: null,
          //   payment_id: 0,
          //   payment_type: getPaymentType[0].type
          // })
          context.dispatch('getRechargeActivityList', {name: userInfo.name, site: userInfo.site})
          Message.success(i18n.t('reward-claimed'))
        } else {
          Message.error(i18n.t(res.message))
        }
      }).catch(err => {
        Message.error("Error in ftd list: "+err.message)
      });
    },

    // INVITATION ACTIVITY
    getInvitationActivityList(context, params) {
      invitationActivityApi(params).then(res => {
        
        context.commit("setInvitationActivityList", res.data);
      }).catch(err => {
        Message.error("Error in invitationactivity list: "+err.message)
      });
    },
    setInvitationActivity(context, params){
      invitationActivityClaimApi(params).then(res => {
        let getPaymentType = context.rootState.recharge.paymentList.payment_type
        let userInfo = context.rootState.auth.userInfo
        if (res.code == 200 && res.status == "success") {
          // context.dispatch('setRecharge',{
          //   attach: null,
          //   bank_code: "NA",
          //   money: params.reward_amount,
          //   payment_desc: null,
          //   payment_id: 0,
          //   payment_type: getPaymentType[0].type
          // })
          context.dispatch('getInvitationActivityList', {name: userInfo.name, site: userInfo.site})
          Message.success(i18n.t('reward-claimed'))
        } else {
          if(res.code == 409) {
            Message.error(i18n.t('user-does-not-exist'))
          } else {
            Message.error(i18n.t(res.message))
          }
        }
      }).catch(err => {
        Message.error(err.response.data.message)
      });
    },

    // RELIEF ACTIVITY
    getReliefActivityList(context, params) {
      lossReliefActivityApi(params).then(res => {
        context.commit("setReliefActivityList", res.data);
      }).catch(err => {
        Message.error(err.response.data.message)
      });
    },
    setReliefActivity(context, params){
      lossReliefActivityClaimApi(params).then(res => {
        let getPaymentType = context.rootState.recharge.paymentList.payment_type
        let userInfo = context.rootState.auth.userInfo
        if (res.code == 200 && res.status == "success") {
          // context.dispatch('setRecharge',{
          //   attach: null,
          //   bank_code: "NA",
          //   money: params.reward_amount,
          //   payment_desc: null,
          //   payment_id: 0,
          //   payment_type: getPaymentType[0].type
          // })
          context.dispatch('getReliefActivityList', {name: userInfo.name, site: userInfo.site})
          Message.success(i18n.t('reward-claimed'))
        } else {
          Message.error(i18n.t(res.message))
        }
      }).catch(err => {
        Message.error(err.response.data.message)
      });
    },

    // RECHARGE REBATE ACTIVITY
    getRechargeRebateDetails(context, params) {
      rechargeRebateActivityCheckApi(params).then(res => {
        if (res.status == "fail") {
          Message.error(res.message);
        }
        if(res.status == "success") {
          context.commit("setRechargeRebateDetails", res.data);
        }
      }).catch(err => {
        Message.error(err.response.data.message)
      })
    },
    setRechargeRebateDetails(context, params) {
      rechargeRebateActivityClaimApi(params).then(res => {
        let getPaymentType = context.rootState.recharge.paymentList.payment_type
        if (res.code == 200 && res.status == "success") {
          // context.dispatch('setRecharge',{
          //   attach: null,
          //   bank_code: "NA",
          //   money: params.reward_amount,
          //   payment_desc: null,
          //   payment_id: 0,
          //   payment_type: getPaymentType[0].type
          // })
          context.dispatch('getRechargeRebateDetails', { member_id: params.member_id })
          Message.success(i18n.t('reward-claimed'))
        }
        if (res.status == "fail"){
          Message.error(res.message);
        }
      }).catch(err => {
        Message.error(err.response.data.message)
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modules/activity.js